import React from 'react'
import ClassNames from 'classnames'
import { CountdownFlipTimerStyle } from './styled'

import FlipCountdown from '@rumess/react-flip-countdown'
//https://www.npmjs.com/package/@rumess/react-flip-countdown

export class CountdownFlipTimer extends React.PureComponent {
  render() {
    const { label, className, disabled, id, showTimeInput } = this.props

    return (
      <CountdownFlipTimerStyle
        className={ClassNames(
          'countdown-filp-timer-wrapper',
          { 'is-disabled': disabled },
          { 'is-inline': showTimeInput },
          className
        )}
      >
        {label && (
          <label className="label" htmlFor={id}>
            {label}
          </label>
        )}
        <FlipCountdown
          size="small"
          titlePosition="bottom"
          {...this.props}
          className="countdown-filp-timer-custom"
          id={id}
        />
      </CountdownFlipTimerStyle>
    )
  }
}
